/** @format */
import {ValueKey} from 'features/forecast/types';

import {getValueDelta} from 'features/forecast/helpers/getValueDelta';
import {Chart, CommonChartData} from 'components/charts/multiline-chart/model/charts';

import {MAX_FORECAST_SPREAD} from '../../constants/common';
import {getPrimaryValuesList} from './getPrimaryValuesList';
import {ChartIds} from '../../models/chartIds';

/**
 * Постобработка готовых прогнозов: ограничивает ШИРИНУ полосы прогноза, не трогая точку.
 *
 * Полоса приходит сверху уже корректной — неотрицательной (floor в calcForecast) и обрамляющей
 * точку (для ratio — распространение погрешности вокруг average в calcComplexForecast; для additive
 * полоса симметрична вокруг среднего). Здесь только ограничиваем, насколько широко её рисовать
 * (слишком широкий прогноз забивал бы график), и сужаем строго ВОКРУГ ТОЧКИ (average), floor в 0 —
 * чтобы линия прогноза всегда оставалась внутри своих min/max.
 * @param charts
 * @param normalPoints
 */

const postProcessing = (charts: Chart<ChartIds>[], normalPoints: ValueKey[]): Chart<ChartIds>[] => {
  return charts.map(chart => {
    const primaryValuesList = getPrimaryValuesList(chart.chartsData, normalPoints);
    const delta = getValueDelta(primaryValuesList);
    const maxWidth = delta * (MAX_FORECAST_SPREAD / 100);

    const newChartsData = chart.chartsData.map(data => {
      const newData: CommonChartData = {
        ...data,
      };

      if (data.range && newData.average !== undefined && data.range[1] - data.range[0] > maxWidth) {
        const half = maxWidth / 2;
        newData.range = [Math.max(0, newData.average - half), newData.average + half];
      }

      return newData;
    });

    return {
      ...chart,
      chartsData: newChartsData,
    };
  });
};

export {postProcessing};
